module.exports = __webpack_public_path__ + "static/media/fixed_voice_arrow_right.6e725cdd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_arrow_right.svg
// module id = 3185
// module chunks = 0